"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var _ = require("lodash");
var baseViewModel_1 = require("./base/baseViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var dateTimeUtils_1 = require("../../app/utils/dateTimeUtils");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.searchQuery = ko.observable();
        this.quickSearchHtml = ko.observable("");
        this.quickSearchVersion = 0;
        this.cancelQuickSearch = function () {
            _this.quickSearchVersion++;
            clearTimeout(_this.quickSearchTimer);
            if (_this.quickSearchRequest) {
                _this.quickSearchRequest.abort();
                _this.quickSearchRequest = null;
            }
            $("#mobileQuickSearchResults").stop(true, false).css("height", "");
        };
        this.clearQuickSearch = function () {
            _this.cancelQuickSearch();
            _this.quickSearchHtml("");
        };
        this.showQuickSearchResults = function (html) {
            var $results = $("#mobileQuickSearchResults");
            var wasOpen = $results.is(":visible");
            $results.stop(true, false);
            var previousHeight = $results.css("height");
            var version = _this.quickSearchVersion;
            if (wasOpen)
                $results.css("height", previousHeight);
            _this.quickSearchHtml(html);
            window.setTimeout(function () {
                if (version !== _this.quickSearchVersion)
                    return;
                $results.css("height", "");
                dateTimeUtils_1.default.displayTime($results);
                if (wasOpen && $results.is(":visible")) {
                    var nextHeight = $results.css("height");
                    $results.css("height", previousHeight).animate({ height: nextHeight }, 200, function () {
                        $results.css("height", "");
                    });
                }
            }, 0);
        };
        this.showFullSearchBtn = ko.pureComputed(function () {
            var q = _this.searchQuery();
            return q && q.length > 0;
        });
        this.format = ko.observable();
        this.form = ko.observable();
        this.genres = ko.observableArray();
        this.exceptGenreIds = ko.observableArray();
        this.state = ko.observable();
        this.series = ko.observable();
        this.access = ko.observable();
        this.download = ko.observable();
        this.lastUpdate = ko.observable();
        this.published = ko.observable();
        this.duration = ko.observable();
        this.length = ko.observable();
        this.sorting = ko.observable();
        this.hideFinished = ko.observable();
        this.favoriteFilter = ko.observable();
        this.seriesOrder = ko.observable();
        this.usingNeuralNetworks = ko.observable();
        this.rp = ko.observable();
        this.resetFilters = function () {
            _this.genres([]);
            _this.format("any");
            _this.form("any");
            _this.exceptGenreIds([]);
            _this.state("any");
            _this.access("any");
            _this.download("any");
            _this.lastUpdate("-1");
            _this.published("-1");
            _this.duration("any");
            _this.length("any");
            _this.favoriteFilter("any");
            _this.sorting("popular");
            _this.hideFinished(false);
            _this.series("any");
            _this.seriesOrder("any");
            _this.usingNeuralNetworks("default");
            _this.favoriteFilter("any");
            _this.submit();
        };
        this.genreCodes = {
            "modern-prose": 1,
            "fantasy": 2,
            "sci-fi": 3,
            "detective": 4,
            "action": 5,
            "romance": 6,
            "erotica": 7,
            "adventure": 8,
            "fanfiction": 9,
            "paranormal": 10,
            "thriller": 11,
            "humor": 12,
            "poetry": 13,
            "non-fiction": 14,
            "teen-prose": 16,
            "historical-fiction": 17,
            "horror": 18,
            "other": 19,
            "litrpg": 20,
            "popadantsy": 21,
            "sf-history": 28,
            "dystopia": 29,
            "sf-action": 30,
            "sf-heroic": 31,
            "postapocalyptic": 32,
            "sf-space": 33,
            "cyberpunk": 34,
            "steampunk": 35,
            "science-fiction": 36,
            "sf-humor": 37,
            "fantasy-action": 38,
            "urban-fantasy": 39,
            "romantic-fantasy": 40,
            "historical-fantasy": 41,
            "ironical-fantasy": 42,
            "epic-fantasy": 43,
            "dark-fantasy": 44,
            "short-romance": 45,
            "historical-romance": 46,
            "popadantsy-vo-vremeni": 47,
            "popadantsy-v-magicheskie-miry": 48,
            "historical-mystery": 50,
            "spy-mystery": 51,
            "detective-science-fiction": 52,
            "romantic-erotika": 53,
            "sf-erotika": 54,
            "fantasy-erotika": 55,
            "fanfiction-erotika": 56,
            "slash": 57,
            "detskaya-literatura": 58,
            "publicism": 59,
            "fairy-tale": 60,
            "biznes-literatura": 61,
            "sf-social": 63,
            "heroic-fantasy": 64,
            "popadantsy-v-kosmos": 66,
            "contemporary-romance": 67,
            "femslesh": 68,
            "realrpg": 69,
            "historical-adventure": 70,
            "boyar-anime": 71,
            "back-to-ussr": 72,
            "wuxia": 73,
            "magic-school": 74,
            "dorama": 75,
            "rusreal": 76,
            "everyday-fantasy": 77,
            "classic-fantasy": 78,
            "slavic-fantasy": 79,
            "techno-fantasy": 80,
            "sf-romantic": 81,
            "drama": 82,
            "magic-detective": 83
        };
        this.searchQuery.subscribe(function () {
            _this.cancelQuickSearch();
            var query = $.trim(_this.searchQuery() || "");
            if (query.length < 2) {
                _this.quickSearchHtml("");
                return;
            }
            var version = _this.quickSearchVersion;
            _this.quickSearchTimer = window.setTimeout(function () {
                if (!_this.quickSearchHtml()) {
                    _this.quickSearchHtml("<p class='text-muted'>Поиск...</p>");
                }
                var request = _this.quickSearchRequest =
                    ajaxUtils_1.AjaxUtils.getHtml("search/quickSearch", { q: query });
                request.done(function (html) {
                    if (version !== _this.quickSearchVersion)
                        return;
                    _this.showQuickSearchResults(html);
                });
                request.fail(function (xhr, status) {
                    if (status === "abort" || version !== _this.quickSearchVersion)
                        return;
                    _this.showQuickSearchResults("<p class='text-muted'>Не удалось загрузить результаты.</p>");
                });
                request.always(function () {
                    if (_this.quickSearchRequest === request) {
                        _this.quickSearchRequest = null;
                    }
                });
            }, 300);
        });
        var self = this;
        this.series.subscribe(function (value) {
            if (value === 'out') {
                self.seriesOrder('any');
            }
        });
    }
    ViewModel.prototype.submit = function (formElement, extendedData) {
        var _this = this;
        var genres = this.genres(), exceptGenreIds = this.exceptGenreIds(), form = this.form(), state = this.state(), series = this.series(), access = this.access(), dnl = this.download(), upd = this.lastUpdate(), pub = this.published(), format = this.format(), duration = this.duration(), length = this.length(), sorting = this.sorting(), fnd = this.hideFinished(), favoriteFilter = this.favoriteFilter(), seriesOrder = this.seriesOrder(), usingNeuralNetworks = this.usingNeuralNetworks(), rp = this.rp();
        var params = {};
        if (state !== "any") {
            params.state = state;
        }
        if (series !== "any") {
            params.series = series;
        }
        if (access !== "any") {
            params.access = access;
        }
        if (dnl !== "any") {
            params.dnl = dnl;
        }
        if (upd !== "-1") {
            params.upd = upd;
        }
        if (pub !== "-1") {
            params.pub = pub;
        }
        if (duration !== "any") {
            params.duration = duration;
        }
        if (length !== "any") {
            params.length = length;
        }
        if (favoriteFilter && favoriteFilter !== "any") {
            params.favoriteFilter = favoriteFilter;
        }
        if (seriesOrder && seriesOrder !== "any") {
            params.seriesOrder = seriesOrder;
        }
        if (rp && rp !== "today") {
            params.rp = rp;
        }
        var deafaultSotring = this.options.deafaultSotring || "popular";
        if (sorting !== deafaultSotring) {
            params.sorting = sorting;
        }
        var defaultUsingNeuralNetworks = this.options.defaultUsingNeuralNetworks;
        if (defaultUsingNeuralNetworks && usingNeuralNetworks != defaultUsingNeuralNetworks) {
            params.usingNeuralNetworks = usingNeuralNetworks;
        }
        var defaultExceptGenres = this.options.defaultExceptGenres;
        if (exceptGenreIds && exceptGenreIds.length) {
            if (!defaultExceptGenres || !defaultExceptGenres.length || ko.toJSON(exceptGenreIds.slice().sort()) !== ko.toJSON(defaultExceptGenres.slice().map(String).sort())) {
                params.eg = _.map(exceptGenreIds, function (x) { return _this.genreCodes[x]; }).join("-");
            }
        }
        else {
            params.eg = "";
        }
        var defaultHideFinished = this.options.defaultHideFinished;
        var fndBool = JSON.parse(fnd.toString());
        if (defaultHideFinished == null ? fndBool : defaultHideFinished != fndBool) {
            params.fnd = fnd;
        }
        var genreCodes;
        if (genres && genres.length > 0) {
            genreCodes = genres.join("&");
        }
        else {
            genreCodes = "all";
        }
        var url = app.rootUrl + this.options.urlFunc(genreCodes, format, form, params);
        window.location.replace(url);
    };
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=searchPopup.js.map